<template>
    <div id="signup-layout" class="col-12 col-lg-5">
        <div id="top" class="row">
            <template v-if="platform == 'task'">
                <img src="https://bucket-tarsresources.s3.sa-east-1.amazonaws.com/images/task/task_100x100.png"/>
                <span class="platform-title-task">task</span>
            </template>
            <template v-if="platform == 'echo'">
                <img src="https://bucket-tarsresources.s3.sa-east-1.amazonaws.com/images/task/echo_100x100.png"/>
                <span class="platform-title-echo">echo</span>
            </template>
            <template v-if="platform == 'react'">
                <img src="https://bucket-tarsresources.s3.sa-east-1.amazonaws.com/images/task/react_100x100.png"/>
                <span class="platform-title-echo">react</span>
            </template>
        </div>
        
        <div id="signup-flow">
            <slot />
        </div>
        
    </div>
</template>


<script>

export default {
    name: 'signup-layout',
    data: function () {
        return {
            platform: this.$route.params.platform   
        }
    }
}

</script>


<style lang="scss">

#signup-layout {

    margin: 0 auto 10px auto;
    
    #top {

        font-family: "Raleway";
        justify-content: center;
        text-align: center;    
        white-space: nowrap;
        align-items: center;
        cursor: pointer;
        margin: 30px auto;

        img {
            width: 50px;
        }

        span {
            font-size: 30px;
            transition: color 0.2s;
        }

        span.platform-title-task {
            color: #666;            
            font-weight: 900;
        }

        span.platform-title-echo {
            color: #333;
            font-weight: 100;
        }

    }

    #signup-flow {

        border: 1px solid rgba(130,130,130,.2);
        box-shadow: 0 2px 3px rgba(130,130,130,.2);
        
    }
}

.text-field-area, .text-field-holder, .text-field, .input-border, .input-border-animate {
  box-sizing: content-box;
}

</style>
